import React from "react";
import { Link } from "react-router-dom";
import "./RoomListItem.css";

const RoomListItem = ({ title, id, subtitle }) => {
  return (
    <li className="RoomListItem">
      <Link to={"/rooms/" + id}>{title}</Link>
      {subtitle && <div className="RoomListItem--subtitle">{subtitle}</div>}
    </li>
  );
};

export default RoomListItem;
